import * as React from 'react';
import { Link } from 'react-router-dom';
import Logger from '../../utilities/logging';

export interface ErrorBoundaryProps {
    children : any,
    /** Controls if error message is shown, if false it will render null */
    showError : boolean,
    /** Override error message */
    errorMessage? : string,
    /** Give a redirect link  */
    redirectLink?: string,
    eventMessage? : string
}

export interface ErrorBoundaryState {
    hasError : boolean,
    error : any,
    errorInfo : any,
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps){
        super(props);
        this.state = {
            hasError : false,
            error : null,
            errorInfo : null,
        }
    }

    static getDerivedStateFromError(error: any) {
        // Update state so the next render will show the fallback UI.
        // //console.log("Error from get derived state", error);
        // return { hasError: true };
        //console.log("ErrorBoundary -> getDerivedStateFromError ->", error);
        Logger.Error({
            EventMessage : `ErrorBoundary -> getDerivedStateFromError -> ${JSON.stringify(error)}`,
            EventCategory : "Component"
        });
    }

    componentDidCatch(error: any, errorInfo: any){
        // Set component state to error true and save error message
        //console.log("ErrorBoundary Error Caught", error, errorInfo);
        this.setState({ 
            hasError : true, 
            error : error, 
            errorInfo : errorInfo 
        });
        let firstPart = this.props.eventMessage || "Component Error";
        let cs = errorInfo?.componentStack ? errorInfo.componentStack.toString() : "";
        Logger.Error({
            EventMessage : firstPart + cs,
            EventCategory : "Component",
        });
    }

    render() { 
        const {showError, redirectLink, children} = this.props;
        if(this.state.errorInfo){
            return(
                <div>
                    {
                        showError 
                        ? 
                        <>
                            <h4>{this.state.error ? this.state.error.toString() : "Sorry there was a problem."}</h4>
                            {
                                redirectLink&&<p>Go back to <Link to={redirectLink}>Dashboard</Link></p>
                            }
                        </>
                        :
                        null
                    }
                </div>
            )
        }
        return children;
    }
}


export default ErrorBoundary;